import React, { useState, useEffect } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Button,
  IconButton,
  TextField,
  Divider,
  Autocomplete,
} from "@mui/material";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { getData, postData } from "../../../ServerRequest";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import MenuIcon from "@mui/icons-material/Menu";
//import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
//import AddIcon from '@mui/icons-material/Add';
//import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
//import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
//import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';

const buttonStyle = {
  background: "#f8f9fa",
  border: "3px solid #b0bec5",
  color: "black",
  fontSize: "0.850rem",
  "&:hover": { background: "#eceff1" },
  fontFamily: "Inter, sans-serif",
};

const inputStyle = {
  height: 35,
  borderRadius: 0,
  fontFamily: "Inter, sans-serif",
  "& .MuiInputBase-root": {
    height: 35,
    borderRadius: 0,
    backgroundColor: "white",
    fontFamily: "Inter, sans-serif",
  },
};

export default function LandingPageFeatured(selectionId) {
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({
    id: "",
    featured_section: "",
    featured_product_image: "",
    featured_name: "",
    link_page: "",
    orientation_number: "",
    collection_name: "",
  });
  const [productTiles, setProductTiles] = useState([]);
  //const [editingIndex, setEditingIndex] = useState(null);
  //const [isVisible, setIsVisible] = useState(false);
  const [collectionOptions, setCollectionOptions] = useState([]);
  const [editableFields, setEditableFields] = useState({
    sub_category_title: false,
    collection_name: {}, // Track editability for each collection name by index
  });
  console.log(selectionId.selectionId);

  const toggleEditableField = (field, index = null) => {
    if (index !== null) {
      setEditableFields((prev) => ({
        ...prev,
        collection_name: {
          ...prev.collection_name,
          [index]: !prev.collection_name[index],
        },
      }));
    } else {
      setEditableFields((prev) => ({ ...prev, [field]: !prev[field] }));
    }
  };

  const filterProducTiles = (productData) => {
    console.log(productData);

    let productTiles = [];
    if (productData) {
      productTiles = productData
        .filter((product) => {
          console.log(selectionId.selectionId);
          console.log(product.featured_section);
          return product.featured_section === selectionId.selectionId;
        })
        .map((product) => {
          return {
            id: product.id,
            featured_section: product.featured_section,
            featured_product_image: product.featured_product_image,
            featured_name: product.featured_name,
            link_page: product.link_page,
            orientation_number: product.orientation_number,
            collection_name: product.collection_name || "",
          };
        });
    }
    console.log(productTiles);
    setProductTiles(productTiles);
    return productTiles;
  };

  useEffect(() => {
    async function fetchProductData() {
      let productResData = await getData("/api/theme/landing_featured_product");
      console.log(productResData);
      let product_data = productResData["data"]["products"];
      product_data = await filterProducTiles(product_data);
      if (product_data) {
        const updatedProductTiles = product_data.map((product) => ({
          ...product,
          collection: product.collection || "",
          collection_url: product.collection_url || "",
        }));
        setProductTiles(updatedProductTiles);
        console.log(product_data);

        // setProductTiles(product_data);
      } else {
        console.error("Error fetching featured product data:", productResData.message);
      }

      let collectionResData = await getData("/api/product/product-collection");
      console.log(collectionResData);
      let collections_data = collectionResData["data"]["live_collections"];
      if (collections_data) {
        const formattedCollections = collections_data.map((collection) => ({
          label: collection.collection || "",
          value: collection.id || "",
          collection_url: collection.collection_url || "",
        }));
        setCollectionOptions(formattedCollections);
      } else {
        console.error("Error fetching collection data:", collectionResData.message);
      }

      setLoading(false);
    }

    fetchProductData();
  }, [selectionId]);

  const handleSaveTile = async (index) => {
    const item = productTiles[index];
    let productReqData = {
      'id': item.id ? item.id : "",
      'featured_section': item.featured_section ? item.featured_section : selectionId.selectionId || "",
      'featured_product_image': item.featured_product_image ? item.featured_product_image : "",
      'featured_name': item.featured_name ? item.featured_name : "",
      'link_page': item.link_page ? item.link_page : "",
      'orientation_number': item.orientation_number ? item.orientation_number : "",
      'collection_name': item.collection_name ? item.collection_name : "",
    };

    const convertToBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    };

    if (
      item.featured_product_imagee &&
      item.featured_product_image instanceof Blob
    ) {
      productReqData.featured_product_image = await convertToBase64(
        item.featured_product_image
      );
    }
    // else if (isEditing && editingImageUrl) {
    //     iconReqData.icon_image = editingImageUrl;
    // }

    console.log(productReqData);

    try {
      let productResData = await postData(
        "/api/theme/landing_featured_product",
        productReqData
      );
      if (productResData["data"]["code"] === "200") {
        alert("Product saved successfully.");
      } else {
        alert("Error in saving product. Please try again.");
      }
    } catch (error) {
      console.error("Error in saving product:", error);
    }
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const img = new Image();
      const imageUrl = URL.createObjectURL(file);
      img.src = imageUrl;
      img.onload = () => {
        if (img.width <= 1440 && img.height <= 300) {
          setFormValues((prevState) => ({
            ...prevState,
            banner_image: imageUrl,
            imageUrl: file,
          }));
        } else {
          alert("Image must be 1440px wide and 300px tall or smaller.");
        }
      };
    }
  };

  const handleCollectionNameChange = (e, index) => {
    const updatedData = [...productTiles];
    updatedData[index].collectionName = e.target.value;
    setProductTiles(updatedData);
  };

  const handleLinkChange = (event, newValue, index) => {
    const updatedProductTiles = [...productTiles];
    if (newValue?.value === "none") {
      updatedProductTiles[index].collection = ""; // Clear the collection when "None" is selected
      updatedProductTiles[index].collection_url = ""; // Clear the URL
      updatedProductTiles[index].collection_name = ""; // Clear the collection name
      updatedProductTiles[index].link_page = ""; // Clear the link_page
      updatedProductTiles[index].isEditable = true; // Enable the text field
    } else {
      updatedProductTiles[index].collection = newValue?.value || ""; // Persist the selected collection
      updatedProductTiles[index].collection_url = newValue?.collection_url || ""; // Persist the collection URL
      updatedProductTiles[index].collection_name = newValue?.label || ""; // Persist the collection name
      updatedProductTiles[index].link_page = newValue?.collection_url || ""; // Update the URL to the selected collection's link_page
      updatedProductTiles[index].isEditable = false; // Disable the text field
    }
    setProductTiles(updatedProductTiles);
  };

  const handleURLChange = (e, index) => {
    const newTiles = [...productTiles];
    newTiles[index].link_page = e.target.value;
    setProductTiles(newTiles);
  };

  const onDragEnd = (result) => {
    if (!result.destination) return;
    const items = Array.from(productTiles);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setProductTiles(items);
  };

  /* const handleEditTile = (e, index) => {
        e.stopPropagation();
        setEditingIndex(index);
    };

    const handleAddTile = () => {
        const newTile = { id: '', featured_section: '', featured_product_image: '', featured_name: '', link_page: '', orientation_number: '' };        
        setProductTiles([...productTiles, newTile])
    };

    const handleDeleteTile = (e, index) => {
        e.stopPropagation();
        const updatedTiles = productTiles.filter((_, i) => i !== index);
        setProductTiles(updatedTiles);
    }; 
    
    const handleToggle = () => {
        setIsVisible((prev) => !prev);
    };*/

  return (
    <Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Box sx={{ width: "100%" }}>
          <Typography
            variant="body1"
            sx={{
              color: "#424956",
              fontFamily: "Inter",
              fontWeight: 700,
              fontSize: 14,
              mt: 1,
            }}
          >
            Sub category title
          </Typography>    
          <Box
            sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            width: "100%",
            }}   
          >
            <TextField
              fullWidth
              disabled={!editableFields.sub_category_title}
              variant="outlined"
              placeholder="Shop top rated"          
              onChange={handleURLChange}
              sx={{ ...inputStyle }}
            />
            <IconButton
              aria-label="edit"
              sx={{ color: "grey" }}
              onClick={() => toggleEditableField("sub_category_title")}
            >
              <EditOutlinedIcon />
            </IconButton>
          </Box> 
        </Box>
      </Box>
      <Typography 
        variant="body1"
        sx={{
          color: "#424956",
          fontFamily: "Inter",
          fontWeight: 700,
          fontSize: 14,
          mt: 2,
          mb: 2,
        }}
      >
        Category cards
      </Typography>
      <Divider sx={{ marginBottom: 3 }} />
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="productTiles">
          {(provided) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              sx={{ display: "flex", flexDirection: "column", gap: 2 }}
            >
              {productTiles.length > 0 ? (
                productTiles.map((tile, index) => (
                  <Draggable
                    key={index}
                    draggableId={index.toString()}
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <Accordion
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        sx={{
                          backgroundColor: "#eceff1",
                          marginBottom: 2,
                          ...provided.draggableProps.style,
                          borderRadius: 0,
                          boxShadow: "none",
                        }}
                      >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 2,
                            }}
                          >
                            <MenuIcon
                              sx={{ cursor: "pointer", marginRight: 0 }}
                            />
                            <Box
                              component="img"
                              src={tile.featured_product_image}
                              sx={{
                                width: 70,
                                height: 40,
                                objectFit: "cover",
                                borderRadius: 0,
                                marginRight: 1,
                              }}
                            />
                            <Typography variant="h7">
                              Fabric Collection card {index + 1}
                            </Typography>
                          </Typography>
                          {/*<div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 1 }}>
                                <IconButton sx={{ mr: 1, color: 'grey', mb: 0, mt: 0}} onClick={(e) => {handleEditTile(e, index); handleToggle();}}>
                                    {isVisible ? <VisibilityOutlinedIcon /> : <VisibilityOffOutlinedIcon />}
                                </IconButton>
                                <IconButton sx={{ mr: 2, color: 'grey' }} onClick={(e) => handleEditTile(e, index)}><EditOutlinedIcon /></IconButton>
                                <IconButton sx={{ color: 'red' }} onClick={(e) => handleDeleteTile(e, index)}><DeleteOutlinedIcon /></IconButton>
                            </div>*/}
                        </AccordionSummary>
                        <AccordionDetails sx={{ padding: 5, pt: 0, mt: 3 }}>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 2,
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 2,
                              }}
                            >
                              <Box
                                component="img"
                                src={tile.featured_product_image}
                                alt="Fabric Collection"
                                sx={{
                                  width: "100%",
                                  maxWidth: "300px",
                                  height: "150px",
                                  border: "1px solid grey",
                                }}
                              />
                              <IconButton
                                component="label"
                                sx={{ color: "black" }}
                              >
                                <FileUploadOutlinedIcon />
                                <input
                                  hidden
                                  accept="image/*"
                                  type="file"
                                  onChange={(e) => handleImageUpload(e, index)}
                                />
                              </IconButton>
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                mt: 2,
                              }}
                            >
                              <Typography
                                variant="body1"
                                sx={{
                                  color: "#424956",
                                  fontFamily: "Inter",
                                  fontWeight: 700,
                                  fontSize: 14,
                                  mt: 1,
                                }}
                              >
                                Collection Name
                              </Typography> 
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 2,
                                  width: "100%",
                                }}
                              > 
                                <TextField                               
                                  disabled={
                                    !editableFields.collection_name[index]
                                  }
                                  variant="outlined"                                
                                  value={tile.featured_name}
                                  onChange={(e) =>
                                    handleCollectionNameChange(e, index)
                                  }
                                  sx={{
                                    width: "100%",                               
                                    "& .MuiInputBase-root": {
                                      borderBottom: "1px solid grey",
                                      borderRadius: 0,
                                      height: 35,
                                    },
                                    "& .MuiOutlinedInput-notchedOutline": {
                                      border: "none",
                                    },
                                  }}
                                />
                                <IconButton
                                  aria-label="edit"
                                  sx={{ color: "grey" }}
                                  onClick={() =>
                                    toggleEditableField("collection_name", index)
                                  }
                                >
                                  <EditOutlinedIcon />
                                </IconButton>
                              </Box>  
                            </Box>
                            <Box>
                              <Typography
                                variant="body1"
                                sx={{
                                  color: "#424956",
                                  fontFamily: "Inter",
                                  fontWeight: 700,
                                  fontSize: 14,
                                  mt: 1,
                                }}
                              >
                                Link collection page
                              </Typography> 
                              <Autocomplete
                                fullWidth
                                options={[
                                  { 
                                    label: "None", 
                                    value: "none", 
                                    collection_url: "" 
                                  },
                                  ...collectionOptions,
                                ]}
                                getOptionLabel={(option) => option.label || ""}
                                value={
                                  collectionOptions.find(
                                    (option) => 
                                      option.value === tile.collection ||
                                      option.label === tile.collection_name
                                  ) || { 
                                    label: tile.collection_name || "None", 
                                    value: tile.collection || "none", 
                                    collection_url: tile.collection_url || "", 
                                  }
                                }
                                onChange={(event, newValue) =>
                                  handleLinkChange(event, newValue, index)
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}                                    
                                    fullWidth
                                    sx={{ ...inputStyle }}
                                  />
                                )}
                              />
                            </Box>
                            <Divider sx={{ margin: 0 }}>OR</Divider>
                            <Typography
                              variant="body1"
                              sx={{
                                color: "#424956",
                                fontFamily: "Inter",
                                fontWeight: 700,
                                fontSize: 14,
                               
                              }}
                            >
                              URL link to collection page
                            </Typography>     
                            <TextField
                              fullWidth                              
                              variant="outlined"
                              placeholder="URL"                              
                              disabled={!tile.isEditable}
                              value={tile.link_page}
                              onChange={(e) => handleURLChange(e, index)}
                              sx={{ ...inputStyle }}
                            />
                          </Box>
                          <Button
                            variant="contained"
                            onClick={() => handleSaveTile(index)}
                            sx={{ ...buttonStyle, mt: 4 }}
                          >
                            Save
                          </Button>
                        </AccordionDetails>
                      </Accordion>
                    )}
                  </Draggable>
                ))
              ) : (
                <Typography>No category tiles available</Typography>
              )}
              {provided.placeholder}
              {/*<IconButton variant="contained" sx={{ ...buttonStyle, mt: 1 }} onClick={handleAddTile}>
                <AddIcon />
              </IconButton>*/}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </Box>
  );
}
